import React from 'react';
import toolboxLogos from 'components/Page/Toolbox/data/toolboxLogos';
import SubNavSubscribeCTA from 'components/SubNav/components/SubNavSubscribeCTA/SubNavSubscribeCTA';

const toolboxDetailSubNav = () => {
  const {
    articlesLogo,
    podcastLogo,
    toolsLogo,
    toolboxLogo,
    webinarLogo,
    downloadLogo,
    growthSeriesLogo,
  } = toolboxLogos();

  return {
    logo: { src: toolboxLogo, alt: 'Toolbox Logo', slug: '/toolbox' },
    navigation: [
      {
        icon: { src: webinarLogo, alt: 'Webinar logo' },
        slug: '/webinar',
        title: 'Webinars',
      },
      {
        icon: { src: articlesLogo, alt: 'Article logo' },
        slug: '/blog',
        title: 'Articles',
      },
      {
        icon: { src: podcastLogo, alt: 'Podcast logo' },
        slug: '/podcast',
        title: 'Podcasts',
      },
      {
        icon: { src: toolsLogo, alt: 'Tools logo' },
        slug: '/tools',
        title: 'Tools',
      },
      {
        icon: { src: articlesLogo, alt: 'Guides logo' },
        slug: '/guides',
        title: 'Guides',
      },
      {
        icon: { src: growthSeriesLogo, alt: 'Growth Series' },
        slug: '/webinar/growth-series',
        title: 'Growth Series',
      },
      /* {
        icon: { src: downloadLogo, alt: 'Download logo' },
        slug: '/toolbox#download',
        title: 'Download',
      }, */
    ],
    cta: <SubNavSubscribeCTA />,
  };
};

export default toolboxDetailSubNav;
